const state = {
    howToCreateTransfer: false,
    startPopupForApp: false
}

const getters = {
    StateHintToCreateTransfer: (state) => !!state.howToCreateTransfer,
    StateStartPopupForApp: (state) => !!state.startPopupForApp
}

const actions = {
    async sawHowToCreateTr({ commit }, bool = true) {
        try {
            await commit("setHowToCreateTr", bool)
        } catch { }
        return true
    },
    async sawStartPopupForApp({ commit }, bool = true) {
        try {
            await commit("setStartPopupForApp", bool)
        } catch { }
        return true
    }
}

const mutations = {
    setHowToCreateTr(state, bool) {
        state.howToCreateTransfer = bool
    },
    setStartPopupForApp(state, bool) {
        state.startPopupForApp = bool
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}